import type { BadgeVariant } from '../../components/ui';
import type { KhoaDich } from '../../i18n';
import type { OcrFileState, OcrUploadOutcome, TranscriptOrigin, TranscriptStatus } from './types';

/**
 * Nhãn và tông của kho bản OCR. Chỉ nhóm **trạng thái** của `Badge` (luật màu ở `xu-ly/constants.ts`):
 * `success` có bản dùng được, `primary` hệ thống đang đọc, `danger` cần người vào xem, `neutral` chưa
 * có gì hoặc bỏ qua không cần quan tâm.
 */
export const TRANG_THAI_TEP: Record<OcrFileState, { khoa: KhoaDich; variant: BadgeVariant }> = {
  READY: { khoa: 'khoOcr.trangThai.READY', variant: 'success' },
  RUNNING: { khoa: 'khoOcr.trangThai.RUNNING', variant: 'primary' },
  FAILED: { khoa: 'khoOcr.trangThai.FAILED', variant: 'danger' },
  EMPTY: { khoa: 'khoOcr.trangThai.EMPTY', variant: 'neutral' },
};

export const TRANG_THAI_BAN: Record<TranscriptStatus, { khoa: KhoaDich; variant: BadgeVariant }> = {
  QUEUED: { khoa: 'khoOcr.trangThaiBan.QUEUED', variant: 'neutral' },
  READING: { khoa: 'khoOcr.trangThaiBan.READING', variant: 'primary' },
  DONE: { khoa: 'khoOcr.trangThaiBan.DONE', variant: 'success' },
  FAILED: { khoa: 'khoOcr.trangThaiBan.FAILED', variant: 'danger' },
};

export const NGUON_BAN: Record<TranscriptOrigin, KhoaDich> = {
  PRE_OCR: 'khoOcr.nguon.PRE_OCR',
  DOCUMENT: 'khoOcr.nguon.DOCUMENT',
  BACKFILL: 'khoOcr.nguon.BACKFILL',
};

export const KET_QUA_TAI: Record<OcrUploadOutcome, { khoa: KhoaDich; variant: BadgeVariant }> = {
  QUEUED: { khoa: 'khoOcr.ketQua.QUEUED', variant: 'primary' },
  SKIPPED_DONE: { khoa: 'khoOcr.ketQua.SKIPPED_DONE', variant: 'neutral' },
  SKIPPED_RUNNING: { khoa: 'khoOcr.ketQua.SKIPPED_RUNNING', variant: 'neutral' },
  REJECTED: { khoa: 'khoOcr.ketQua.REJECTED', variant: 'danger' },
  FAILED: { khoa: 'khoOcr.ketQua.FAILED', variant: 'danger' },
};
